module.exports = __webpack_public_path__ + "img/solar.d9e4e4f4.png";